(() => {
  'use strict';
  const key = '__kbHalloweenDecorV2';
  if (window[key]) { window[key].mount(document); return; }
  const script = document.currentScript || document.querySelector('script[data-kb-halloween-script]');
  const label = script?.dataset.spiderLabel || '';
  if (!label) return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Map();
  const mobile = window.matchMedia('(max-width: 700px)');
  const searchSlots = new Map();
  const spiderSelector = '[data-kb-halloween-spider]';
  const decorSelector = '[data-kb-halloween-static-web], [data-kb-halloween-scene], [data-kb-halloween-spider]';
  let frame = 0;
  const cancel = (button) => {
    const state = active.get(button);
    if (!state) return;
    active.delete(button);
    if (state.timer) window.clearTimeout(state.timer);
    if (state.animation) {
      state.animation.onfinish = null;
      state.animation.oncancel = null;
      state.animation.cancel();
    }
    state.art.hidden = false;
    button.removeAttribute('data-kb-spider-active');
  };
  const restoreSearch = (root) => {
    [...searchSlots.entries()].forEach(([header, state]) => {
      if (root !== document && root !== header && !root.contains(header)) return;
      if (state.slot.parentNode) state.slot.replaceWith(state.search);
      else if (state.actions.isConnected) state.actions.prepend(state.search);
      state.search.classList.remove('kb-mobile-search-action');
      searchSlots.delete(header);
    });
  };
  const arrangeMobileHeader = () => {
    if (!mobile.matches || !document.body.classList.contains('kb-halloween')) {
      restoreSearch(document);
      return;
    }
    document.querySelectorAll('.kb-header').forEach((header) => {
      if (searchSlots.has(header)) return;
      const inner = header.querySelector('.kb-header__inner');
      const actions = header.querySelector('.kb-actions');
      const search = actions?.querySelector('[data-search-open]');
      const logo = inner?.querySelector('.kb-logo');
      if (!search || !logo) return;
      const slot = document.createComment('kb-search-position');
      actions.insertBefore(slot, search);
      searchSlots.set(header, {search, slot, actions});
      search.classList.add('kb-mobile-search-action');
      inner.insertBefore(search, logo);
    });
  };
  const clear = (root) => {
    restoreSearch(root);
    root.querySelectorAll?.(spiderSelector).forEach(cancel);
    root.querySelectorAll?.(decorSelector).forEach((node) => node.remove());
    root.querySelectorAll?.('[data-kb-halloween-corner]').forEach((node) => node.remove());
  };
  const align = () => {
    arrangeMobileHeader();
    document.querySelectorAll(spiderSelector).forEach((button) => {
      button.hidden = false;
      const header = button.parentElement;
      const logo = header.querySelector('.kb-logo');
      if (!logo) return;
      const a = header.getBoundingClientRect(), b = logo.getBoundingClientRect(), c = button.getBoundingClientRect();
      const gap = mobile.matches ? 6 : 10;
      if (b.width && c.width) button.style.left = `${b.left - a.left - c.width - gap}px`;
      const r = button.getBoundingClientRect();
      button.hidden = [...header.querySelectorAll('a, button, input, select, summary')].filter((node) => node !== button && !button.contains(node)).some((node) => {
        const t = node.getBoundingClientRect();
        return r.width > 0 && t.width > 0 && r.left < t.right && r.right > t.left && r.top < t.bottom && r.bottom > t.top;
      });
    });
  };
  const scheduleAlign = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => { frame = 0; align(); });
  };
  const elements = (root, selector) => {
    const found = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) found.unshift(root);
    return found;
  };
  const mount = (root = document) => {
    root.querySelectorAll?.('[data-kb-halloween-corner]').forEach((node) => node.remove());
    if (!document.body.classList.contains('kb-halloween')) { clear(document); return; }
    elements(root, '.kb-hero, .kb-showcase, .kb-footer').forEach((surface) => {
      if (!surface.querySelector(':scope > [data-kb-halloween-static-web]')) {
        ['left', 'right'].forEach((side) => {
          const web = document.createElement('div');
          web.className = `kb-halloween-static-web kb-halloween-static-web--${side}`;
          web.setAttribute('data-kb-halloween-static-web', '');
          web.setAttribute('aria-hidden', 'true');
          surface.append(web);
        });
      }
      if (surface.matches('.kb-hero') && !surface.querySelector(':scope > [data-kb-halloween-scene]')) {
        ['night', 'pumpkins', 'branches'].forEach((kind) => {
          const detail = document.createElement('div');
          detail.className = `kb-halloween-scene kb-halloween-scene--${kind}`;
          detail.setAttribute('data-kb-halloween-scene', '');
          detail.setAttribute('aria-hidden', 'true');
          surface.append(detail);
        });
      }
    });
    elements(root, '.kb-header').forEach((header) => {
      if (header.querySelector(':scope > ' + spiderSelector)) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'kb-halloween-spider';
      button.setAttribute('data-kb-halloween-spider', '');
      button.setAttribute('aria-label', label);
      const art = document.createElement('span');
      art.className = 'kb-halloween-spider__art';
      art.setAttribute('aria-hidden', 'true');
      button.append(art);
      header.append(button);
    });
    scheduleAlign();
  };
  const retract = (button) => {
    if (active.has(button) || !document.body.classList.contains('kb-halloween')) return;
    const art = button.querySelector('.kb-halloween-spider__art');
    const state = {art, animation: null, timer: 0};
    active.set(button, state);
    button.setAttribute('data-kb-spider-active', '');
    const finish = () => {
      if (active.get(button) !== state) return;
      active.delete(button);
      art.hidden = false;
      button.removeAttribute('data-kb-spider-active');
    };
    if (motion.matches || typeof art.animate !== 'function') {
      art.hidden = true;
      state.timer = window.setTimeout(finish, 140);
      return;
    }
    try {
      state.animation = art.animate([
        {transform: 'translateY(0)', offset: 0, easing: 'cubic-bezier(.55,0,.85,.5)'},
        {transform: 'translateY(-105%)', offset: .28},
        {transform: 'translateY(-105%)', offset: .46, easing: 'cubic-bezier(.15,.65,.25,1)'},
        {transform: 'translateY(0)', offset: 1}
      ], {duration: 1050, fill: 'none'});
      state.animation.onfinish = finish;
      state.animation.oncancel = finish;
    } catch (_) { finish(); }
  };
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest(spiderSelector) : null;
    if (button) retract(button);
  });
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => clear(event.target));
  document.addEventListener('shopify:section:reorder', scheduleAlign);
  window.addEventListener('resize', scheduleAlign, {passive: true});
  window.addEventListener('load', scheduleAlign, {once: true});
  const motionChanged = () => { if (motion.matches) [...active.keys()].forEach(cancel); };
  if (motion.addEventListener) motion.addEventListener('change', motionChanged);
  else if (motion.addListener) motion.addListener(motionChanged);
  window[key] = {mount};
  mount(document);
})();
